/*
 * @Author: edvardchen
 * @Date:   2016-12-26 17:49:34
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:26:34
 */

import React from 'react';

const style = {
  position: 'absolute',
  width: '100%',
  top: '50%',
  transform: 'translateY(-50%)',
};

export default function withCenterPosition(Wrapped) {
  // eslint-disable-next-line react/display-name
  return (props) => (
    <div style={style}>
      <Wrapped {...props} />
    </div>
  );
}
